import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientSearchCriteria } from 'src/app/clients/shared/client-search-criteria.model';
import { ClientsService } from 'src/app/clients/shared/clients.service';
import { EventsService } from 'src/app/events/shared/events.service';
import { Client } from 'src/app/shared/models/Client';
import { SearchObjectResult } from 'src/app/shared/models/SearchObject';
import * as XLSX from "xlsx";

@Component({
    selector: 'app-statistics-customers',
    templateUrl: './statistics-customers.component.html',
    styleUrls: ['./statistics-customers.component.scss'],
    standalone: false
})
export class StatisticsCustomersComponent implements OnInit {

  public columns: any;

  public currentStatus: number = undefined;

  public clientEvents2019;
  public clientEvents2020;
  public clientEvents2021;
  public clientEvents2022;
  public clientEvents2023;
  public clientEvents2024;
  public clientEvents2025;
  public clientEvents2026;

  filters: ClientSearchCriteria = {};

  loadPage: (page: number, pageSize: number) => Observable<SearchObjectResult<Client>> = null;
  public tBodyTrAdditionalClass = 'alternateBgColor';

  @ViewChild('selectColumn', { static: true })
  selectColumn: TemplateRef<any>;

  @ViewChild('customerName', { static: true })
  customerName: TemplateRef<any>;

  @ViewChild('emailColumn', { static: true })
  emailColumn: TemplateRef<any>;

  @ViewChild('phoneColumn', { static: true })
  phoneColumn: TemplateRef<any>;

  @ViewChild('registrationYearColumn', { static: true })
  registrationYearColumn: TemplateRef<any>;

  @ViewChild('confirmedAtColumn', { static: true })
  confirmedAtColumn: TemplateRef<any>;

  @ViewChild('statusColumn', { static: true })
  statusColumn: TemplateRef<any>;

  @ViewChild('languageColumn', { static: true })
  languageColumn: TemplateRef<any>;

  @ViewChild('surveyAnswerColumn', { static: true })
  surveyAnswerColumn: TemplateRef<any>;

  @ViewChild('companyNameColumn', { static: true })
  companyColumn: TemplateRef<any>;

  @ViewChild('companyEmailColumn', { static: true })
  companyEmailColumn: TemplateRef<any>;

  @ViewChild('companyPhoneColumn', { static: true })
  companyPhoneColumn: TemplateRef<any>;

  @ViewChild('companyStatusColumn', { static: true })
  companyStatusColumn: TemplateRef<any>;

  @ViewChild('events2019Column', { static: true })
  events2019Column: TemplateRef<any>;

  @ViewChild('events2020Column', { static: true })
  events2020Column: TemplateRef<any>;

  @ViewChild('events2021Column', { static: true })
  events2021Column: TemplateRef<any>;

  @ViewChild('events2022Column', { static: true })
  events2022Column: TemplateRef<any>;

  @ViewChild('events2023Column', { static: true })
  events2023Column: TemplateRef<any>;

  @ViewChild('events2024Column', { static: true })
  events2024Column: TemplateRef<any>;

  @ViewChild('events2025Column', { static: true })
  events2025Column: TemplateRef<any>;

  @ViewChild('events2026Column', { static: true })
  events2026Column: TemplateRef<any>;

  @ViewChild('actionsColumn', { static: true })
  actionsColumn: TemplateRef<any>;

  constructor(private _clientService: ClientsService, private _eventService: EventsService) {
    this.loadPage = (page: number, pageSize: number) => this._clientService.search(page, pageSize, this.filters);
   }

  ngOnInit() {

    this.clientEvents2019 = new Map();
    this.clientEvents2020 = new Map();
    this.clientEvents2021 = new Map();
    this.clientEvents2022 = new Map();
    this.clientEvents2023 = new Map();
    this.clientEvents2024 = new Map();
    this.clientEvents2025 = new Map();
    this.clientEvents2026 = new Map();

    this.columns = [
      {
        name: 'select',
        displayed: true,
        translationKey: '',
        template: this.selectColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'customerName',
        displayed: true,
        translationKey: 'Customer name',
        template: this.customerName,
        sortable: true,
        trAddidionalClass: 'text-center'
      },
      {
        name: 'email',
        displayed: true,
        translationKey: 'client-list.email.label',
        template: this.emailColumn,
        sortable: true
      },
      {
        name: 'phone',
        displayed: true,
        translationKey: 'Phone',
        template: this.phoneColumn,
        sortable: true
      },
      {
        name: 'registrationYear',
        displayed: true,
        translationKey: 'registration',
        template: this.registrationYearColumn,
        sortable: true
      },
      {
        name: 'confirmedAt',
        displayed: true,
        translationKey: 'confirmedAt',
        template: this.confirmedAtColumn,
        sortable: true
      },
      {
        name: 'status',
        displayed: true,
        translationKey: 'Status',
        template: this.statusColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'language',
        displayed: true,
        translationKey: 'language',
        template: this.languageColumn,
        sortable: true,
      },
      {
        name: 'surveyAnswer',
        displayed: true,
        translationKey: 'Survey Answer',
        template: this.surveyAnswerColumn,
        sortable: true,
      },
      {
        name: 'company',
        displayed: true,
        translationKey: 'client-list.company.label',
        template: this.companyColumn,
        sortable: true
      },
      {
        name: 'companyEmail',
        displayed: true,
        translationKey: 'Company Email',
        template: this.companyEmailColumn,
        sortable: true
      },
      {
        name: 'companyPhone',
        displayed: true,
        translationKey: 'Company Phone',
        template: this.companyPhoneColumn,
        sortable: true,
        trAddidionalClass: 'text-center'
      },
      {
        name: 'companyStatus',
        displayed: true,
        translationKey: 'Company status',
        template: this.companyStatusColumn,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'events2019',
        displayed: true,
        translationKey: 'Events 2019',
        template: this.events2019Column,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'events2020',
        displayed: true,
        translationKey: 'Events 2020',
        template: this.events2020Column,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'events2021',
        displayed: true,
        translationKey: 'Events 2021',
        template: this.events2021Column,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'events2022',
        displayed: true,
        translationKey: 'Events 2022',
        template: this.events2022Column,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'events2023',
        displayed: true,
        translationKey: 'Events 2023',
        template: this.events2023Column,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'events2024',
        displayed: true,
        translationKey: 'Events 2024',
        template: this.events2024Column,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'events2025',
        displayed: true,
        translationKey: 'Events 2025',
        template: this.events2025Column,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'events2026',
        displayed: true,
        translationKey: 'Events 2026',
        template: this.events2026Column,
        sortable: true,
        additionalClass: 'text-center',
        trAddidionalClass: 'text-center'
      },
      {
        name: 'actions',
        displayed: true,
        translationKey: '',
        template: this.actionsColumn,
        sortable: true,
        additionalClass: 'text-right'
      }
    ];

    this._eventService.getEvents().subscribe(res => {
      res.forEach(e => {
        const date = e.startDate.substring(0, e.startDate.indexOf('-'));
        switch (date) {
          case '2019':
            if (this.clientEvents2019.has(e.clientUser.id)) {
              this.clientEvents2019.set(e.clientUser.id, this.clientEvents2019.get(e.clientUser.id) + 1);
            } else {
              this.clientEvents2019.set(e.clientUser.id, 1);
            }
            break;
          case '2020':
            if (this.clientEvents2020.has(e.clientUser.id)) {
              this.clientEvents2020.set(e.clientUser.id, this.clientEvents2020.get(e.clientUser.id) + 1);
            } else {
              this.clientEvents2020.set(e.clientUser.id, 1);
            }
            break;
          case '2021':
            if (this.clientEvents2021.has(e.clientUser.id)) {
              this.clientEvents2021.set(e.clientUser.id, this.clientEvents2021.get(e.clientUser.id) + 1);
            } else {
              this.clientEvents2021.set(e.clientUser.id, 1);
            }
            break;
          case '2022':
            if (this.clientEvents2022.has(e.clientUser.id)) {
              this.clientEvents2022.set(e.clientUser.id, this.clientEvents2022.get(e.clientUser.id) + 1);
            } else {
              this.clientEvents2022.set(e.clientUser.id, 1);
            }
            break;
          case '2023':
            if (this.clientEvents2023.has(e.clientUser.id)) {
              this.clientEvents2023.set(e.clientUser.id, this.clientEvents2023.get(e.clientUser.id) + 1);
            } else {
              this.clientEvents2023.set(e.clientUser.id, 1);
            }
            break;
          case '2024':
            if (this.clientEvents2024.has(e.clientUser.id)) {
              this.clientEvents2024.set(e.clientUser.id, this.clientEvents2024.get(e.clientUser.id) + 1);
            } else {
              this.clientEvents2024.set(e.clientUser.id, 1);
            }
            break;
          case '2025':
            if (this.clientEvents2025.has(e.clientUser.id)) {
              this.clientEvents2025.set(e.clientUser.id, this.clientEvents2025.get(e.clientUser.id) + 1);
            } else {
              this.clientEvents2025.set(e.clientUser.id, 1);
            }
            break;
          case '2026':
            if (this.clientEvents2026.has(e.clientUser.id)) {
              this.clientEvents2026.set(e.clientUser.id, this.clientEvents2026.get(e.clientUser.id) + 1);
            } else {
              this.clientEvents2026.set(e.clientUser.id, 1);
            }
            break;
        }
      });
    })

  }

  onTableReset() {
    if (this.currentStatus) {
      this.filters.status = this.currentStatus.toString();
    }
  }

  exportData() {

    let element = document.getElementById('filterTable');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'Export Customers.xlsx');

  }

}
